module.exports = __webpack_public_path__ + "fonts/prompt-v4-thai_latin-600.de34a552.woff";